import React from 'react'

function DisqualifiedRevenueIcon() {
  return (
    <svg width="24" height="27" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.4468 22.2083V6.79167C25.4468 3.44933 19.7717 0.625 13.0525 0.625C6.33324 0.625 0.658203 3.44933 0.658203 6.79167V22.2083C0.658203 25.5507 6.33324 28.375 13.0525 28.375C19.7717 28.375 25.4468 25.5507 25.4468 22.2083ZM13.0525 3.70833C18.7709 3.70833 22.2413 6.03162 22.3482 6.78242C22.2413 7.55171 18.7709 9.875 13.0525 9.875C7.33408 9.875 3.86368 7.55171 3.75678 6.80092C3.86368 6.03162 7.33408 3.70833 13.0525 3.70833ZM3.75678 10.8108C6.04817 12.1166 9.39153 12.9583 13.0525 12.9583C16.7135 12.9583 20.0568 12.1166 22.3482 10.8108V14.4908C22.2413 15.26 18.7709 17.5833 13.0525 17.5833C7.33408 17.5833 3.86368 15.26 3.75678 14.5V10.8108ZM3.75678 22.2083V18.5191C6.04817 19.8249 9.39153 20.6667 13.0525 20.6667C16.7135 20.6667 20.0568 19.8249 22.3482 18.5191V22.1991C22.2413 22.9684 18.7709 25.2917 13.0525 25.2917C7.33408 25.2917 3.86368 22.9684 3.75678 22.2083Z"
        fill="#4E87F8"
      />
    </svg>
  )
}

export default DisqualifiedRevenueIcon
